export default __webpack_public_path__ + "static/media/fisher-funds-logo-bird.c2ca7141.svg";